<dashboardnav>

  <cradua-title
  [titles]="titles$ | async"
  (title)="onSubmitTitle($event)"
  (deleteTitleEvent)="onDeleteTitle($event)"
  *ngIf="(isLoading$ | async ) === false"
  >
</cradua-title>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoading$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
